// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productLinesStyles } from "@guestsupply/Overrides/Widgets/BrandDetails/BrandDetailsProductLines";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 20px;
        padding-bottom: 5px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

productLinesStyles.productLineContainer = {
    gap: 30,
};

productLinesStyles.innerProductLineContainer = {
    gap: 0,
    css: css`
        box-shadow: 0 0 4px 0 ${color("common.ui7", 0.15)};
        padding: 10px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        &:hover {
            box-shadow: 0 0 8px 0 ${color("common.ui7", 0.15)};
        }
    `,
};

productLinesStyles.productLineItemRow = {
    width: [12, 6, 3, 3, 3],
};

productLinesStyles.productLineImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: 200px;
        justify-content: center;
    `,
};

productLinesStyles.productLineImage = {
    css: css`
        height: 100%;
        width: 200px;

        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};

productLinesStyles.productLineNameLink = {
    typographyProps: {
        size: 18,
        weight: 400,
        css: css`
            margin-bottom: 0;
            overflow-wrap: break-word;
            word-wrap: break-word;
            text-align: center;
        `,
    },
    color: "text.main",
};

productLinesStyles.productLineName = {
    variant: "h5",
    weight: 400,
    css: css`
        margin-bottom: 0;
        overflow-wrap: break-word;
        word-wrap: break-word;
        text-align: center;
    `,
};

productLinesStyles.productLineInfo = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            width: 100%;
        `,
    },
};

productLinesStyles.titleItem = {
    width: 12,
    css: css`
        width: 100%;
        justify-content: center;
    `,
};

productLinesStyles.container = {
    css: css`
        margin: 15px;
    `,
};

productLinesStyles.productLineItemColumn = {
    width: [6, 6, 12, 12, 12],
};

productLinesStyles.productLineNameItem = {
    width: 12,
    css: css`
        width: 100%;
        padding-bottom: 5px;
    `,
};

productLinesStyles.viewAllButtonItem = {
    width: 12,
    css: css`
        padding-top: 5px;
        width: 100%;
        justify-content: center;
    `,
};

productLinesStyles.viewAllButton = {
    typographyProps: {
        weight: "bold",
        ellipsis: true,
    },
};
